module.exports = __webpack_public_path__ + "static/media/motor-license.677a55df.jpeg";